import { render, staticRenderFns } from "./licen-dialog.vue?vue&type=template&id=561dcac8&scoped=true"
import script from "./licen-dialog.vue?vue&type=script&lang=js"
export * from "./licen-dialog.vue?vue&type=script&lang=js"
import style0 from "./licen-dialog.vue?vue&type=style&index=0&id=561dcac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561dcac8",
  null
  
)

export default component.exports